// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1513":"28411ebc","3430":"b6c31f94","8169":"496b8a14","8378":"87bbcec5"}[chunkId] + ".chunk.css";
};